export enum StepTypes {
    checkbox = 0,
    upload_file = 20,
    email = 1,
    document_request = 2,
    signature_request = 3,
    approval_request = 4,
    survey = 5,
    payment_request = 6,
    webhook = 7,
    standard_operating_procedure = 8,
    conditional = 9,
    activate_client_portal = 10,
    appointment_request = 11,
    question_request = 12,
    checklist = 13,
    checklist_request = 14,
    important_file_upload = 21
}

export let AutomaticStepTypes = [
    StepTypes.email,
    StepTypes.document_request,
    StepTypes.approval_request,
    StepTypes.survey,
    StepTypes.payment_request,
    StepTypes.webhook,
    StepTypes.activate_client_portal,
    StepTypes.appointment_request,
    StepTypes.question_request,
    StepTypes.checklist_request
];

export let ClientStepTypes = [
    StepTypes.email,
    StepTypes.document_request,
    StepTypes.approval_request,
    StepTypes.survey,
    StepTypes.payment_request,
    StepTypes.appointment_request,
    StepTypes.question_request,
    StepTypes.checklist_request
]



